import { QUERY_KEYS } from "@/libraries/constant";
import type { CreateGroupSchema } from "@/schemas";
import type { CreateGroupResponse, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useCreateGroup() {
	return useMutation<CreateGroupResponse, ResError, CreateGroupSchema>({
		mutationKey: [QUERY_KEYS.MUTATE_GROUP_CREATE],
	});
}

export default useCreateGroup;
